module.exports = __webpack_public_path__ + "assets/img/404_img.44d51420.png";